export default __webpack_public_path__ + "static/8-3007e0192dab1c8f21cf9673c4c7cd71.png";